import { isBrowser } from './isBrowser';
export function isReact(): boolean {
  return isBrowser() ? window.isReact : false;
}
